import { IFaireDirectDiscountSummary } from "@faire/web-api--source/indigofair/brand/direct/IFaireDirectDiscountSummary";
import { useLocalNum } from "@faire/web/common/localization";
import {
  useFormatMoney,
  moneyOrZero,
  RoundingStrategy,
} from "@faire/web/common/money";

import { useFaireDirectInfoForVisitorQuery } from "./__internal__/useFaireDirectInfoForVisitorQuery";
import { BrandTokenOrBrandAlias } from "./faireDirectTypes";

export const useFaireDirectOfferInfoForVisitor = (
  params: BrandTokenOrBrandAlias
) => {
  const { data, isPending } = useFaireDirectInfoForVisitorQuery(params);
  const faireDirectOffer = data?.faire_direct_discount_summary;
  const { localNum } = useLocalNum();
  const { formatMoney } = useFormatMoney();
  const { discount_percentage, max_percentage_discount_amount, discount_type } =
    faireDirectOffer ?? {};
  const hasDefinedPercentageBasedDiscount =
    !!discount_percentage &&
    discount_type === IFaireDirectDiscountSummary.DiscountType.PERCENTAGE;
  const formattedPercentageNumber = discount_percentage
    ? localNum(discount_percentage / 100, { style: "percent" })
    : "";
  const formattedMaxPercentageDiscountMoney = formatMoney({
    money: moneyOrZero(max_percentage_discount_amount),
    roundingStrategy: RoundingStrategy.DROP_CENTS,
    disableAutoConvertCurrency: true,
  });
  return {
    isPending,
    hasDefinedPercentageBasedDiscount,
    formattedPercentageNumber,
    formattedMaxPercentageDiscountMoney,
  };
};
